import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmForm";
import {cancelAssignDefaultCreditCard} from "../../actions/AccountApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class AssignDefaultCreditCardFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.assignDefaultPaymentMethod({accountId: this.props.accountId, paymentMethodId: this.props.paymentMethodId})
      .then((response) => {
        if (response.data.assignDefaultPaymentMethod.errors.length <= 0) {
          this.props.cancelAssignDefaultCreditCard();
        } else {
          let errors = createValidationErrors(response.data.assignDefaultPaymentMethod.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelAssignDefaultCreditCard();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        message="Are you sure you want to make this payment method the default?"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const ASSIGN_DEFAULT_CARD = gql`
  mutation assignDefaultPaymentMethod($data: AssignDefaultPaymentMethodInput!) {
    assignDefaultPaymentMethod(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(ASSIGN_DEFAULT_CARD, {
    props: ({ mutate }) => ({
      assignDefaultPaymentMethod: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelAssignDefaultCreditCard})(withMutation(AssignDefaultCreditCardFormContainer));